'use client';

import { useEffect, useState, type ReactNode } from 'react';

/**
 * Figma „Sticky scroll“ (146:8503 desktop, 263:26086 mobile): the header stays at the top. Once the
 * page scrolls it gets the shadow 0 4 24 / 12 % and, from 1024 px, the compact rows (padding 8 / 4
 * instead of 16 / 8 – rows read `group-data-[stuck]/header`). The 24 px it loses go to the bottom
 * margin with the same transition, so the page under it never moves.
 */
export function StickyHeader({ children }: { children: ReactNode }) {
  const [isStuck, setStuck] = useState(false);

  useEffect(() => {
    const update = () => setStuck(window.scrollY > 0);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <header
      data-stuck={isStuck || undefined}
      className="ea-header group/header sticky top-0 z-30 bg-white transition-[box-shadow,margin] duration-200 ease-out data-[stuck]:shadow-[0_4px_24px_rgba(0,0,0,0.12)] motion-reduce:transition-none lg:data-[stuck]:mb-6"
    >
      {children}
    </header>
  );
}
